import { render, staticRenderFns } from "./ResendForm.vue?vue&type=template&id=026a79e0&"
import script from "./ResendForm.vue?vue&type=script&lang=js&"
export * from "./ResendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports